'use strict';//Indicating browser should run only in java script mode
; (function () {

    var ruleOutViewModuleRoutes = [
        {
            name: "RuleOutView",
            url: "RuleOutView",
            templateUrl: "AngularScripts/RuleOutView/Htmls/RuleOutView.html",
            RoutingNumber: 4694,
            files: [
                "AngularScripts/EhrAgGridHandler/Factories/EhrAgGridHandlerFactory.js",
                "AngularScripts/RuleOutView/Services/RuleOutViewService.js",
                "AngularScripts/RuleOutView/Controllers/RuleOutViewController.js",
            ]
        },
    ];
    angular.module('EMR.RuleOutViewModule', [])
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(ruleOutViewModuleRoutes, $stateProvider);
            }]);
})();
